export default __webpack_public_path__ + "static/media/missedCall.70e322ae.jpg";